import * as React from 'react'
import { Callout, CalloutProps, Button } from '@blueprintjs/core'
import * as Cookies from 'es-cookie'

export interface Props {
  calloutProps?: CalloutProps
  nagKey: string
  dismissForDays: number
}
/**
 *
 * @example
 * <Nag nagKey="LISTER_CONNECT_UPGRADE" dismissForDays={1}>
   <p><b>Upgrade to Lister Connect!</b></p>
   <p>In 30 days, you'll need to install Lister Connect in order to print all of your labels.</p>
   <AnchorButton href="https://intercom.help/upright-labs/en/collections/1965285-printing" target="_blank" rel="noopener" intent="primary">Get started</AnchorButton>
  </Nag>
 */
const Nag: React.FC<Props> = ({ calloutProps, children, nagKey, dismissForDays }) => {
  const [shouldShow, setShouldShow] = React.useState(true)

  React.useEffect(() => {
    setShouldShow(!(Cookies.get(nagKey) === '1'))
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount only
  }, [])

  const dismiss = () => {
    Cookies.set(nagKey, '1', { expires: dismissForDays })
    setShouldShow(false)
  }

  if (shouldShow === false) return null

  return (
    <Callout className="screen-only" intent="none" {...calloutProps}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>{children}</div>
        <Button onClick={dismiss} style={{ alignSelf: 'flex-start', marginLeft: 'auto' }} minimal icon="cross" />
      </div>
    </Callout>
  )
}

export default Nag
